import React from "react";
import { Constants } from "../../CommonMethhods/Constants";

// Helper function to render table cells
const renderCell = (value) => value ?? "-";

const ClientHoldingTable = (props) => {
  const { data, seg } = props;
  console.log(data, "data");

  const headers =
    seg === "stocks"
      ? [
        Constants.Scrip_Name, "ISIN", "Avg. Cost Price", "DP Holding", Constants.BFL_Pledge,
        Constants.Margin_Pledge, "MTF Qty", Constants.MTF_Pledge,
        "Unpaid Qty", "Unsettle Qty", Constants.Total_Holding,
        "Close Rate", "Holding Value"
      ]
      : seg === "total"
        ? [
          "Scrip Name", "ISIN", "Avg. Cost Price", "DP Holding", "BFL Pledge",
          "Margin Pledge", "MTF Qty", "MTF Pledge", "Unpaid Qty",
          "Unsettle Qty", "Total Holding", "MF Qty", "Close Rate",
          "Holding Value", "Invest Amount"
        ]
        : [
          "Scheme Name", "ISIN", "Avg. Cost Price", "Units", "Purchase Value",
          "Current Value", "DP Type", "DP ID", "Purchase Date",
          "Client Code", "Client ID", "Client Name"
        ];

  const renderHeaders = headers.map((header, index) => (
    <th key={index} scope="col" className="text-center">
      {header}
    </th>
  ));

  const renderRows = (item) => {
    if (seg === "stocks") {
      return (
        <>
          <td>{renderCell(item.scripName)}</td>
          <td>{renderCell(item.isin)}</td>
          <td>{renderCell(item.avgPrice)}</td>
          <td>{renderCell(item.dpHold)}</td>
          <td>{renderCell(item.bflPledge)}</td>
          <td>{renderCell(item.marginPledge)}</td>
          <td>{renderCell(item.mtfQty)}</td>
          <td>{renderCell(item.mtfPledge)}</td>
          <td>{renderCell(item.unpaidQty)}</td>
          <td>{renderCell(item.unsettelQty)}</td>
          <td>{renderCell(item.totalHolding)}</td>
          <td>{renderCell(item.closeRate)}</td>
          <td>{renderCell(item.holdingValue)}</td>
        </>
      );
    } else if (seg === "total") {
      return (
        <>
          <td>{renderCell(item.scripName)}</td>
          <td>{renderCell(item.isin)}</td>
          <td>{renderCell(item.avgPrice)}</td>
          <td>{renderCell(item.dpHold)}</td>
          <td>{renderCell(item.bflPledge)}</td>
          <td>{renderCell(item.marginPledge)}</td>
          <td>{renderCell(item.mtfQty)}</td>
          <td>{renderCell(item.mtfPledge)}</td>
          <td>{renderCell(item.unpaidQty)}</td>
          <td>{renderCell(item.unsettelQty)}</td>
          <td>{renderCell(item.totalHolding)}</td>
          <td>{renderCell(item.mfQty)}</td>
          <td>{renderCell(item.closeRate)}</td>
          <td>{renderCell(item.holdingValue)}</td>
          <td>{renderCell(item.investAmount)}</td>
        </>
      );
    }

    // Default segment
    return (
      <>
         <td>{renderCell(item.schemeName)}</td>
        <td>{renderCell(item.isin)}</td>
        <td>{renderCell(item.avgCost)}</td>
        <td>{renderCell(item.BalanceUnits)}</td>
        <td>{renderCell(item.PurchaseValue)}</td>
        <td>{renderCell(item.CurrentValue)}</td>
        <td>{renderCell(item.dptype)}</td>
        <td>{renderCell(item.dpid)}</td>
        <td>{renderCell(item.PurchaseDate)}</td>
        <td>{renderCell(item.ClientCode)}</td>
        <td>{renderCell(item.ClientId)}</td>
        <td>{renderCell(item.ClientName)}</td>
      </>
    );
  };

  return (
    <div className="table-responsive scroll-table report-table-wrapper">
      <table className="table last-column client-holding-table">
        <thead>
          <tr>{renderHeaders}</tr>
        </thead>
        <tbody>
          {data && data.map((item, key) => (
            <tr key={key}>
              {renderRows(item)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ClientHoldingTable;



// import React from "react";
// import { Constants } from "../../CommonMethhods/Constants";

// // Helper function to render table cells
// const renderCell = (value) => value ?? "-";

// const ClientHoldingTable = (props) => {
//   const { data, seg } = props;

//   const headers = seg === "stocks"
//     ? [
//         Constants.Scrip_Name, "ISIN", "Avg. Cost Price", "DP Holding", Constants.BFL_Pledge,
//         Constants.Margin_Pledge, "MTF Qty", Constants.MTF_Pledge,
//         "Unpaid Qty", "Unsettle Qty", Constants.Total_Holding,
//         "Close Rate", "Holding Value"
//       ]
//     : [
//         Constants.Scrip_Code, Constants.Isin, "Avg. Cost Price", Constants.POA_hold, "DP Type",
//         "DP ID", "Pledged Qty.", "Free Qty.", "Total Qty.", "Closing Rate",
//         "Value", "Client ID"
//       ];

//   const renderHeaders = headers.map((header, index) => (
//     <th key={index} scope="col" className="text-center">
//       {header}
//     </th>
//   ));

//   const renderRows = (item) => {
//     if (seg === "stocks") {
//       return (
//         <>
//           <td>{renderCell(item.scripName) || "-"}</td>
//           <td>{renderCell(item.isin) || "-"}</td>
//           <td>{renderCell(item.avgPrice)}</td>
//           <td>{renderCell(item.dpHold)}</td>
//           <td>{renderCell(item.bflPledge)}</td>
//           <td>{renderCell(item.marginPledge)}</td>
//           <td>{renderCell(item.mtfQty)}</td>
//           <td>{renderCell(item.mtfPledge)}</td>
//           <td>{renderCell(item.unpaidQty)}</td>
//           <td>{renderCell(item.unsettelQty)}</td>
//           <td>{renderCell(item.totalHolding)}</td>
//           <td>{renderCell(item.closeRate)}</td>
//           <td>{renderCell(item.holdingValue)}</td>
//         </>
//       );
//     }

//     return (
//       <>
//         <td>{renderCell(item.scripName)}</td>
//         <td>{renderCell(item.isin)}</td>
//         <td>{renderCell(item.avgPrice)}</td>
//         <td>{renderCell(item.defaultPOA)}</td>
//         <td>{renderCell(item.dptype)}</td>
//         <td>{renderCell(item.dpid)}</td>
//         <td>{renderCell(item.pledgedQty)}</td>
//         <td>{renderCell(item.freeQty)}</td>
//         <td>{renderCell(item.totalQty)}</td>
//         <td>{renderCell(item.closingRate)}</td>
//         <td>{renderCell(item.value)}</td>
//         <td>{renderCell(item.clientId)}</td>
//       </>
//     );
//   };

//   return (
//     <div className="table-responsive scroll-table report-table-wrapper">
//       <table className="table last-column client-holding-table">
//         <thead>
//           <tr>{renderHeaders}</tr>
//         </thead>
//         <tbody>
//           {data && data.map((item, key) => (
//             <tr key={key}>
//               {renderRows(item)}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default ClientHoldingTable;
